const TYPES = {
    GET_INFLUENCER_PROFILE: 'GET_INFLUENCER_PROFILE',
    GET_INFLUENCER_PROFILE_SUCCESS: 'GET_INFLUENCER_PROFILE_SUCCESS',
    GET_INFLUENCER_PROFILE_FAILED: 'GET_INFLUENCER_PROFILE_FAILED',

    CREATE_INFLUENCER_PROFILE: 'CREATE_INFLUENCER_PROFILE',
    CREATE_INFLUENCER_PROFILE_SUCCESS: 'CREATE_INFLUENCER_PROFILE_SUCCESS',
    CREATE_INFLUENCER_PROFILE_FAILED: 'CREATE_INFLUENCER_PROFILE_FAILED',

    REACTIVATE_INFLUENCER_PROFILE: 'REACTIVATE_INFLUENCER_PROFILE',
    REACTIVATE_INFLUENCER_PROFILE_SUCCESS: 'REACTIVATE_INFLUENCER_PROFILE_SUCCESS',
    REACTIVATE_INFLUENCER_PROFILE_FAILED: 'REACTIVATE_INFLUENCER_PROFILE_FAILED',

    RESEND_EMAIL_VERIFICATION: 'RESEND_EMAIL_VERIFICATION',
    RESEND_EMAIL_VERIFICATION_SUCCESS: 'RESEND_EMAIL_VERIFICATION_SUCCESS',
    RESEND_EMAIL_VERIFICATION_FAILED: 'RESEND_EMAIL_VERIFICATION_FAILED',

    GET_AFFILIATE_SOCIAL_CHANNELS: 'GET_AFFILIATE_SOCIAL_LINKS',
    GET_AFFILIATE_SOCIAL_CHANNELS_SUCCESS: 'GET_AFFILIATE_SOCIAL_CHANNELS_SUCCESS',
    GET_AFFILIATE_SOCIAL_CHANNELS_FAILED: 'GET_AFFILIATE_SOCIAL_CHANNELS_FAILED',

    UPDATE_AFFILIATE_MAIN_CHANNEL: 'UPDATE_AFFILIATE_MAIN_CHANNEL',
    UPDATE_AFFILIATE_MAIN_CHANNEL_SUCCESS: 'UPDATE_AFFILIATE_MAIN_CHANNEL_SUCCESS',
    UPDATE_AFFILIATE_MAIN_CHANNEL_FAILED: 'UPDATE_AFFILIATE_MAIN_CHANNEL_FAILED',

    DISCONNECT_AFFILIATE_SOCIAL_CHANNEL: 'DISCONNECT_AFFILIATE_SOCIAL_CHANNEL',
    DISCONNECT_AFFILIATE_SOCIAL_CHANNEL_SUCCESS: 'DISCONNECT_AFFILIATE_SOCIAL_CHANNEL_SUCCESS',
    DISCONNECT_AFFILIATE_SOCIAL_CHANNEL_FAILED: 'DISCONNECT_AFFILIATE_SOCIAL_CHANNEL_FAILED',

    UPDATE_AFFILIATE_PROFILE: 'UPDATE_AFFILIATE_PROFILE',
    RESET_DISCONNECTED_PLATFORM: 'RESET_DISCONNECTED_PLATFORM',

    ACCEPT_AGREEMENT: 'ACCEPT_AGREEMENT',
    ACCEPT_AGREEMENT_SUCCESS: 'ACCEPT_AGREEMENT_SUCCESS',
    ACCEPT_AGREEMENT_FAILED: 'ACCEPT_AGREEMENT_FAILED',

    CLOSE_ACCOUNT: 'CLOSE_ACCOUNT',
    CLOSE_ACCOUNT_SUCCESS: 'CLOSE_ACCOUNT_SUCCESS',
    CLOSE_ACCOUNT_FAILED: 'CLOSE_ACCOUNT_FAILED',

    GET_FINAL_PAYOUT: 'GET_FINAL_PAYOUT',
    GET_FINAL_PAYOUT_SUCCESS: 'GET_FINAL_PAYOUT_SUCCESS',
    GET_FINAL_PAYOUT_FAILED: 'GET_FINAL_PAYOUT_FAILED',

    UPDATE_OAUTH_CHANNEL: 'UPDATE_OAUTH_CHANNEL',
    UPDATE_OAUTH_CHANNEL_COMPLETE: 'UPDATE_OAUTH_CHANNEL_COMPLETE',
    UPDATE_OAUTH_CHANNEL_FAILED: 'UPDATE_OAUTH_FAILED',

    CHECK_CODE_AVAILABILITY: 'CHECK_CODE_AVAILABILITY',
    CHECK_CODE_AVAILABILITY_SUCCESS: 'CHECK_CODE_AVAILABILITY_SUCCESS',
    CHECK_CODE_AVAILABILITY_FAILED: 'CHECK_CODE_AVAILABILITY_FAILED'
};

export default {
    TYPES,

    getInfluencerProfile: (payload?) => ({
        type: TYPES.GET_INFLUENCER_PROFILE,
        payload
    }),

    getInfluencerProfileSuccess: (payload?) => ({
        type: TYPES.GET_INFLUENCER_PROFILE_SUCCESS,
        payload
    }),

    getInfluencerProfileFailed: (error?) => ({
        type: TYPES.GET_INFLUENCER_PROFILE_FAILED,
        payload: {error}
    }),

    createInfluencerProfile: (payload?) => ({
        type: TYPES.CREATE_INFLUENCER_PROFILE,
        payload
    }),

    createInfluencerProfileSuccess: (payload?) => ({
        type: TYPES.CREATE_INFLUENCER_PROFILE_SUCCESS,
        payload
    }),

    createInfluencerProfileFailed: (error?) => ({
        type: TYPES.CREATE_INFLUENCER_PROFILE_FAILED,
        payload: {error}
    }),

    reactivateInfluencerProfile: (payload?) => ({
        type: TYPES.REACTIVATE_INFLUENCER_PROFILE,
        payload
    }),

    reactivateInfluencerProfileSuccess: (payload?) => ({
        type: TYPES.REACTIVATE_INFLUENCER_PROFILE_SUCCESS,
        payload
    }),

    reactivateInfluencerProfileFailed: (error?) => ({
        type: TYPES.REACTIVATE_INFLUENCER_PROFILE_FAILED,
        payload: {error}
    }),

    resendEmailVerification: () => ({
        type: TYPES.RESEND_EMAIL_VERIFICATION
    }),

    resendEmailVerificationSuccess: (payload?) => ({
        type: TYPES.RESEND_EMAIL_VERIFICATION_SUCCESS,
        payload
    }),

    resendEmailVerificationFailed: (error?) => ({
        type: TYPES.RESEND_EMAIL_VERIFICATION_FAILED,
        payload: {error}
    }),

    getSocialChannels: () => ({
        type: TYPES.GET_AFFILIATE_SOCIAL_CHANNELS
    }),

    getSocialChannelsSuccess: (payload?) => ({
        type: TYPES.GET_AFFILIATE_SOCIAL_CHANNELS_SUCCESS,
        payload
    }),

    getSocialChannelsFailed: (error?) => ({
        type: TYPES.GET_AFFILIATE_SOCIAL_CHANNELS_FAILED,
        payload: {error}
    }),

    updateMainChannel: (payload?) => ({
        type: TYPES.UPDATE_AFFILIATE_MAIN_CHANNEL,
        payload
    }),

    updateMainChannelSuccess: (payload?) => ({
        type: TYPES.UPDATE_AFFILIATE_MAIN_CHANNEL_SUCCESS,
        payload
    }),

    updateMainChannelFailed: (error?) => ({
        type: TYPES.UPDATE_AFFILIATE_MAIN_CHANNEL_FAILED,
        payload: {error}
    }),

    disconnectSocialChannel: (payload?) => ({
        type: TYPES.DISCONNECT_AFFILIATE_SOCIAL_CHANNEL,
        payload
    }),

    disconnectSocialChannelSuccess: (payload?) => ({
        type: TYPES.DISCONNECT_AFFILIATE_SOCIAL_CHANNEL_SUCCESS,
        payload
    }),

    disconnectSocialChannelFailed: (payload?) => ({
        type: TYPES.DISCONNECT_AFFILIATE_SOCIAL_CHANNEL_FAILED,
        payload
    }),

    updateAffiliateProfile: (payload?) => ({
        type: TYPES.UPDATE_AFFILIATE_PROFILE,
        payload
    }),

    resetDisconnectedPlatform: (payload?) => ({
        type: TYPES.RESET_DISCONNECTED_PLATFORM,
        payload
    }),

    acceptAgreement: (payload?) => ({
        type: TYPES.ACCEPT_AGREEMENT,
        payload
    }),

    acceptAgreementSuccess: (payload?) => ({
        type: TYPES.ACCEPT_AGREEMENT_SUCCESS,
        payload
    }),

    acceptAgreementFailed: (error?) => ({
        type: TYPES.ACCEPT_AGREEMENT_FAILED,
        payload: {error}
    }),

    closeAccount: (payload?) => ({
        type: TYPES.CLOSE_ACCOUNT,
        payload
    }),

    closeAccountSuccess: (payload?) => ({
        type: TYPES.CLOSE_ACCOUNT_SUCCESS,
        payload
    }),

    closeAccountFailed: (error?) => ({
        type: TYPES.CLOSE_ACCOUNT_FAILED,
        payload: {error}
    }),

    getFinalPayout: (payload?) => ({
        payload,
        type: TYPES.GET_FINAL_PAYOUT
    }),

    getFinalPayoutSuccess: (payload?) => ({
        payload,
        type: TYPES.GET_FINAL_PAYOUT_SUCCESS
    }),

    getFinalPayoutFailed: (payload?) => ({
        payload,
        type: TYPES.GET_FINAL_PAYOUT_FAILED
    }),

    updateOAuthChannel: (payload?) => ({
        type: TYPES.UPDATE_OAUTH_CHANNEL,
        payload
    }),

    updateOAuthChannelSuccess: (payload?) => ({
        type: TYPES.UPDATE_OAUTH_CHANNEL_COMPLETE,
        payload
    }),

    updateOAuthChannelFailed: (error?) => ({
        type: TYPES.UPDATE_OAUTH_CHANNEL_FAILED,
        payload: {error}
    }),

    checkCodeAvailability: (code: string) => ({
        payload: {
            code
        },
        type: TYPES.CHECK_CODE_AVAILABILITY
    }),

    checkCodeAvailabilitySuccess: (payload?) => ({
        payload,
        type: TYPES.CHECK_CODE_AVAILABILITY_SUCCESS
    }),

    checkCodeAvailabilityFailed: (error?) => ({
        payload: {error},
        type: TYPES.CHECK_CODE_AVAILABILITY_FAILED
    })
};
